/* eslint-disable class-methods-use-this, no-dupe-class-members */

export default class ParentSender {
  send() {
  }

  ready() {
    return Promise.resolve(true);
  }
}
